<div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-md-10 featured-box">
                    <div>
                        <div class="pb-4 mobilepb-0">
                            <ul role="tablist" id="home-events" class="nav nav-tabs qtech-menu">
                                <li class="nav-item" *ngFor="let provider of casinoList;let i = index;" (click)="getProviderGame(provider?.providerCode)">
                                    <a href="javascript:void(0)" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#home-tab" role="tab" class="nav-link" >
                                        {{provider?.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="home-products-container">
                            <div class="row row5 hide-large">
                                <div class="col-md-12">
                                    <h4 class="text-uppercase pb-3">Qtech Casino</h4>
                                </div>
                            </div>
                            <div class="row row5">
                                <div class="col-md-12 casino-list">
                                    <a  *ngFor="let list of providerGames;let i = index;" (click)="gotoexchangeGame(list)">
                                        <div class="d-inline-block casinoicons" >
                                            <img [src]="list.images[1].url" class="img-fluid">
                                            <div class="casino-name">{{list?.name}}</div>
                                            <!-- <div class="new-launch-casino"><img src="assets/diamond_img/offer-patch.png" class="hide-small">
                                                <span class="hide-large">New Launch</span>
                                            </div> -->
                                        </div>
                                    </a>
                                    <!-- <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Race 20-20</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/queen.jpg" class="img-fluid">
                                            <div class="casino-name">Casino Queen</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/cricketv3.jpg" class="img-fluid">
                                            <div class="casino-name">5Five Cricket</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/andar-bahar2.jpg" class="img-fluid">
                                            <div class="casino-name">Andar Bahar 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">20-20 Dragon Tiger 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Baccarat 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Baccarat</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Lucky 7 - B</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Teenpatti 2.0</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">20-20 Cricket Match</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Casino Meter</div>
                                        </div>
                                    </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>

<app-footer-main></app-footer-main>